module.exports = __webpack_public_path__ + "img/12.3c1d2bc4.png";